import { accountsStorageKey } from 'App/components/utils/providers/AppUserProvider';
import { IAppUserMeta } from 'App/types';

export interface ISdkSessionParams {
  cookieAuth?: boolean;
  username?: string;
  account?: string;
}

/** SDK settings for the account in the URL (/u/N); nothing without REACT_APP_SESSION_AUTH. */
export const sdkSessionParams = (): ISdkSessionParams => {
  if ( process.env.REACT_APP_SESSION_AUTH !== 'true' ) {
    return {};
  }

  const index = Number( window.location.pathname.match( /^\/u\/(\d+)(?:\/|$)/ )?.[1] ?? 0 );
  let accounts: IAppUserMeta[] = [];
  try {
    accounts = JSON.parse( localStorage.getItem( accountsStorageKey ) || '[]' );
  } catch {
    accounts = [];
  }
  const account = accounts[index];

  // Unknown account: today's defaults, never another tab's account.
  return account ? { cookieAuth: true, username: account.userName, account: account.sub } : {};
};

/** None when the build does not opt in, so the SDK keeps today's defaults. */
export const sessionConfiguration = <C>( Ctor: new ( params: ISdkSessionParams ) => C ): C | undefined => {
  const params = sdkSessionParams();

  return params.cookieAuth ? new Ctor( params ) : undefined;
};

/** One SDK object per account: each new object adds an interceptor to the shared axios. */
export const perAccount = <T>( create: () => T ): ( () => T ) => {
  const made = new Map<string, T>();

  return () => {
    const key = sdkSessionParams().account ?? '';
    if ( !made.has( key ) ) {
      made.set( key, create() );
    }

    return made.get( key ) as T;
  };
};
